/**
 * External dependencies
 */
import styled from '@emotion/styled';

/**
 * Internal dependencies
 */
import { inputControl } from '../../utils/input';

export const StyledTextarea = styled.textarea`
	width: 100%;
	${ inputControl }
`;
